var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    {
      attrs: {
        "is-modified":
          !!_vm.hasCareerResumes ||
          !!_vm.excludesDisabledScout ||
          !!_vm.includesResend,
        half: _vm.half,
        label: "その他",
      },
    },
    [
      _c("div", { staticClass: "boss-layout boss-layout-start" }, [
        _vm.hasCareerResumes !== undefined
          ? _c(
              "label",
              {
                staticClass: "boss-checkbox",
                attrs: { "data-test": "has-career-resumes" },
              },
              [
                _c("input", {
                  staticClass: "boss-input-checkbox",
                  attrs: { type: "checkbox" },
                  domProps: { checked: _vm.hasCareerResumes },
                  on: {
                    change: function ($event) {
                      return _vm.$emit(
                        "update:hasCareerResumes",
                        $event.target.checked
                      )
                    },
                  },
                }),
                _vm._v("「職務経歴」登録済みのみ\n    "),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.excludesDisabledScout !== undefined
          ? _c(
              "label",
              {
                staticClass: "boss-checkbox",
                attrs: { "data-test": "excludes-disabled-scout" },
              },
              [
                _c("input", {
                  staticClass: "boss-input-checkbox",
                  attrs: { type: "checkbox" },
                  domProps: { checked: _vm.excludesDisabledScout },
                  on: {
                    change: function ($event) {
                      return _vm.$emit(
                        "update:excludesDisabledScout",
                        $event.target.checked
                      )
                    },
                  },
                }),
                _vm._v("アプローチ不可能な会員を表示しない\n    "),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.includesResend !== undefined
          ? _c(
              "label",
              {
                staticClass: "boss-checkbox",
                attrs: { "data-test": "includes-resend" },
              },
              [
                _c("input", {
                  staticClass: "boss-input-checkbox",
                  attrs: { type: "checkbox" },
                  domProps: { checked: _vm.includesResend },
                  on: {
                    change: function ($event) {
                      return _vm.$emit(
                        "update:includesResend",
                        $event.target.checked
                      )
                    },
                  },
                }),
                _vm._v("本日配信不可能な会員を表示しない\n    "),
              ]
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }